import {
  AnalyticsTwitterDashboardOverview,
  AnalyticsTwitterDashboardFeedPosts,
  AnalyticsTwitterDashboardPostsOverview
} from '@anytag/shared-organisms';
import { useAnalyticsProfileContext } from '../../analytics-profile-context';

export const AnalyticsTwitterDashboard = () => {
  const { brandAccount, selectedSocialAccount } = useAnalyticsProfileContext();

  return (
    <>
      <AnalyticsTwitterDashboardOverview analyticsAccount={selectedSocialAccount} />
      <AnalyticsTwitterDashboardPostsOverview analyticsAccount={selectedSocialAccount} />
      <AnalyticsTwitterDashboardFeedPosts
        analyticsAccount={selectedSocialAccount}
        brandAccountName={brandAccount.brandAccountName}
      />
    </>
  );
};
